import React, { useEffect, useState, useRef, useContext } from "react";

import { Button, Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import { Autoplay, Grid } from "swiper/modules";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import TitleWithLine from "../../components/TitleWithLine";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import SkeletonAmusementGroup from "../../components/SkeletonComponent/SkeletonAmusementGroup";
import CardTile from "../../components/CardTile";
import { isMobile } from "react-device-detect";
import ApiHome from "../../../core/api/api.home";
import ContextApp from "./../../../core/contexts/context.app";
import { Link } from "react-router-dom";

function HomeContent() {
  /**** اطلاعات مربوط به اسلایدر اصلی ***************/
  const [loading, setLoading] = useState(true);
  const ctx = useContext(ContextApp);

  const [liveData, setLiveData] = useState({
    amusementGroups: [],
    maxOffAmusementServices: [],
    galleries: [],
    mostPopularAmusementServices: [],
  });
  
  useEffect(() => {
    (async () => {
        const data = await ApiHome.getInfos();

      setLiveData(data);
      setLoading(false);
    })();
  }, []);
  /**** اطلاعات مربوط به بخش دسته بندی تفریحات ***************/
  /**** اطلاعات مربوط به بخش پرطرفدارترین تفریحات ***************/
  const [dataAmusementSlider, setDataAmusementSlider] = useState([]);
  /**** وقتی وارد این صفحه می شود اسکرول بخوره به ابتدای صفحه **********************/
  const handleClick = (value) => {};
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /****  وقتی موس روی  قسمت دسته بندی تفریحات حالت دسکتاپ قرار میگره ، اسلایدر متوقف بشه ************* */
  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };

  /**************** */
  return isMobile ? (
    /***** حالت موبایل ******************************* */
    <Container className="pt-3 margin-bottom-page">
      {/*** اسلایدر ***************************************/}
      {loading ? (
        <SkeletonTheme>
          <Skeleton
            height={130}
            width="100%"
            style={{ borderRadius: "0.75rem" }}
          ></Skeleton>
        </SkeletonTheme>
      ) : (
        <Swiper
          dir="rtl"
          spaceBetween={0}
          slidesPerView={1}
          className="image-slider-swiper"
        >
          {liveData?.galleries?.map((itemImageSlider) => (
            <SwiperSlide key={itemImageSlider.id}>
              <picture>
                <source
                  media="(max-width: 767px)"
                  srcSet={
                    process.env.REACT_APP_API_URL +
                    itemImageSlider.imageUrl +
                    "?width=345"
                  }
                />
                <img
                  onLoad={() => {
                    setLoading(false);
                  }}
                  src={
                    process.env.REACT_APP_API_URL +
                    itemImageSlider.imageUrl +
                    "?width=345"
                  }
                  alt={itemImageSlider.imageAlt}
                  className="w-100 rounded-3"
                />
              </picture>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
      {/*** بخش دسته بندی تفریحات ***************************************************/}
      <TitleWithLine titleText="دسته بندی تفریحات کیش" />
      {loading ? (
        /*** نمایش پیشفرض قبل از لود شدن داده ها********************/
        <Swiper slidesPerView={2.7}>
          <SwiperSlide>
            <SkeletonAmusementGroup />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonAmusementGroup />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonAmusementGroup />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonAmusementGroup />
          </SwiperSlide>
        </Swiper>
      ) : (
        /*** نمایش  داده ها******************************************/
        <Row className="gx-0">
          <Swiper slidesPerView={2.7}>
            {liveData?.amusementGroups?.map((item) => (
              <SwiperSlide
                key={item.id}
                className="text-center amusement-group"
              >
                <Link
                  className="w-100 mt-1 mt-lg-1 d-inline-block text-dark "
                  to={
                    ctx.selectedCity?.englishName == undefined
                      ? `/c/${item.urlName?.split(" ").join("-")}`
                      : `/c/${ctx.selectedCity?.englishName}/${item.urlName
                          ?.split(" ")
                          .join("-")}`
                  }
                >
                  <div className="circle-box d-flex align-items-center mx-auto">
                    <img
                      src={
                        process.env.REACT_APP_API_URL +
                        item.imageUrl +
                        "?width=102"
                      }
                      alt={item.title}
                      className="w-100 p-1 rounded-circle"
                    />
                  </div>
                  <span className="mb-0 mt-3  text-truncate-1-line ">
                    {item.title}
                  </span>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </Row>
      )}

      {/*** بخش پرطرفدارترین تفریحات ***************************************************/}
      <TitleWithLine titleText=" پرطرفدارترین تفریحات کیش" />
      {loading ? (
        <Swiper
          className="amusement-swiper"
          spaceBetween={15}
          slidesPerView={"auto"}
        >
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
        </Swiper>
      ) : (
        <Swiper
          className="amusement-swiper"
          spaceBetween={15}
          slidesPerView={"auto"}
        >
          {liveData?.mostPopularAmusementServices?.map((item) => (
            <SwiperSlide key={item.id}>
              <CardTile
                itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                amusementUrl={`/details/${item.urlName}`}
                amusementName={item.name}
                amusementPrice={item.price}
                amusementFinalPrice={item.originalPrice}
                handleClick={handleClick}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/*** بخش تفریحات با بیشترین تخفیف ***************************************************/}
      <TitleWithLine titleText="تفریحات با بیشترین تخفیف" />
      {loading ? (
        <Swiper
          className="amusement-swiper"
          spaceBetween={15}
          slidesPerView={"auto"}
        >
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
          <SwiperSlide>
            <SkeletonDetailsContetnt />
          </SwiperSlide>
        </Swiper>
      ) : (
        <Swiper
          className="amusement-swiper"
          spaceBetween={15}
          slidesPerView={"auto"}
        >
          {liveData?.maxOffAmusementServices?.map((item, index) => (
            <SwiperSlide key={index}>
              <CardTile
                itemImgSrc={process.env.REACT_APP_API_URL + item.imageUrl}
                amusementUrl={`/details/${item.urlName}`}
                amusementName={item.name}
                amusementPrice={item.price}
                amusementFinalPrice={item.originalPrice}
                handleClick={handleClick}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </Container>
  ) : (
    <>
      {/***** حالت دسکتاپ ***********************************/}
      <Container>
        {/*** اسلایدر ***************************************/}
        {loading ? (
          <SkeletonTheme>
            <Skeleton
              height={460}
              width="100%"
              style={{ borderRadius: "0.75rem" }}
            ></Skeleton>
          </SkeletonTheme>
        ) : (
          <Swiper
            spaceBetween={15}
            slidesPerView={1}
            className="image-slider-swiper"
          >
            {liveData?.galleries?.map((itemImageSlider) => (
              <SwiperSlide key={itemImageSlider.id}>
                <picture>
                  <source
                    media="(min-width: 992px)"
                    srcSet={
                      process.env.REACT_APP_API_URL + itemImageSlider.imageUrl
                    }
                  />
                  <img
                    onLoad={() => {
                      setLoading(false);
                    }}
                    src={
                      process.env.REACT_APP_API_URL + itemImageSlider.imageUrl
                    }
                    alt={itemImageSlider.imageAlt}
                    className="w-100 rounded-3"
                  />
                </picture>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {/*** بخش دسته بندی تفریحات ***********************/}
        <Row className="gx-0 border rounded-3 position-relative mt-5">
          <h2 className="box-title fw-bold fs-101">دسته بندی تفریحات کیش</h2>
          <div
            className="pt-5 px-3"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {loading ? (
              /*** نمایش پیشفرض قبل از لود شدن داده ها********************/
              <Swiper
                className="amusement-group-swiper"
                spaceBetween={5}
                slidesPerView={"auto"}
              >
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
                <SwiperSlide>
                  <SkeletonAmusementGroup />
                </SwiperSlide>
              </Swiper>
            ) : (
              /*** نمایش  داده ها******************************************/
              <Swiper
                className="amusement-group-swiper"
                spaceBetween={50}
                slidesPerView={"auto"}
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                modules={[Autoplay]}
                ref={swiperRefLocal}
              >
                {liveData?.amusementGroups?.map((item) => (
                  <SwiperSlide>
                    <Link
                      className="w-100 mt-3 mt-lg-1 d-inline-block"
                      to={
                        ctx.selectedCity?.englishName == undefined
                          ? `/c/${item.urlName?.split(" ").join("-")}`
                          : `/c/${ctx.selectedCity?.englishName}/${item.urlName
                              ?.split(" ")
                              .join("-")}`
                      }
                    >
                      <div
                        key={item.id}
                        className="text-center amusement-group"
                      >
                        <div className="circle-box d-flex align-items-center mx-auto">
                          <img
                            src={
                              process.env.REACT_APP_API_URL +
                              item.imageUrl +
                              "?width=112"
                            }
                            alt={item.title}
                            className="w-100 p-1 "
                          />
                        </div>
                        <span className="mb-4 mt-1 mt-lg-2 text-truncate-1-line text-dark">
                          {item.title}
                        </span>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </Row>
      </Container>
      {/****  پرطرفدارترین تفریحات کیش ******************/}
      <Container fluid className="bg-light-blue">
        <Container>
          <Row className=" gx-0 mt-4 rounded-3">
            <div className="py-4">
              <div className="d-flex justify-content-center pt-3 pb-4">
                <h2 className="text-start fw-bold text-primary fs-101 my-auto">
                  پرطرفدارترین تفریحات کیش
                </h2>
                <hr className="border-bottom " />
                <div className=" my-auto">
                  {/* <Button
                    size="sm"
                    className="rounded-pill px-4"
                    variant="outline-primary"
                  >
                    مشاهده همه
                  </Button> */}
                </div>
              </div>
              <Swiper
                spaceBetween={10}
                slidesPerView={"auto"}
                className="amusement-swiper"
              >
                {loading ? (
                  <>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </>
                ) : (
                  liveData?.mostPopularAmusementServices?.map((item) => (
                    <SwiperSlide key={item.id}>
                      <CardTile
                        itemImgSrc={
                          process.env.REACT_APP_API_URL + item.imageUrl
                        }
                        amusementUrl={`/details/${item.urlName}`}
                        amusementName={item.name}
                        amusementPrice={item.price}
                        amusementFinalPrice={item.originalPrice}
                        handleClick={handleClick}
                      />
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
          </Row>
        </Container>
      </Container>

      {/****  بیشترین تخفیفات تفریحات کیش ******************/}
      <Container fluid className="">
        <Container>
          <Row className=" gx-0 mt-2 rounded-3">
            <div className="py-4">
              <div className="d-flex justify-content-center pt-3 pb-4">
                <h2 className="text-start fw-bold text-primary fs-101 my-auto">
                  تفریحات با بیشترین تخفیف
                </h2>
                <hr className="border-bottom " />
                <div className=" my-auto">
                  {/* <Button
                    size="sm"
                    className="rounded-pill px-4"
                    variant="outline-primary"
                  >
                    مشاهده همه
                  </Button> */}
                </div>
              </div>

              <Swiper
                spaceBetween={10}
                slidesPerView={"auto"}
                className="amusement-swiper"
              >
                {loading ? (
                  <>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </>
                ) : (
                  liveData?.maxOffAmusementServices?.map((item) => (
                    <SwiperSlide key={item.id}>
                      <CardTile
                        itemImgSrc={
                          process.env.REACT_APP_API_URL + item.imageUrl
                        }
                        amusementUrl={`/details/${item.urlName}`}
                        amusementName={item.name}
                        amusementPrice={item.price}
                        amusementFinalPrice={item.originalPrice}
                        handleClick={handleClick}
                      />
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
          </Row>
          <Container>
            <Row className=" gx-0 mt-2 rounded-3">
              <div></div>
            </Row>
          </Container>
        </Container>
      </Container>
    </>
  );
}
export default HomeContent;
